// extracted by mini-css-extract-plugin
module.exports = {"cookiesRequired":"cookiesRequired_cookiesRequired__Qh8KI"};